module.exports = __webpack_public_path__ + "img/zoom_512x512.58471576.png";